export const tableHeaders = [
  { title: 'Contrato', ordering: false },
  { title: 'Produto', ordering: false },
  { title: 'Valor', numeric: true, ordering: false },
];
